export default {
    skillCenter: {
        title: 'Skill Center',
        searchPlaceholder: 'Search skills...',
        createSkill: 'Create Skill',
        aiCreate: 'Create with AI',
        noSkills: 'No skills',
        noSkillsDesc: 'Click "Create Skill" to add your first skill',
        preview: 'Preview',
        edit: 'Edit',
        aiEdit: 'Edit with AI',
        delete: 'Delete',
        cancel: 'Cancel',
        save: 'Save',
        close: 'Close',
        moreActions: 'More Actions',
        official: 'Official',
        custom: 'Custom',
        enabled: 'Enabled',
        disabled: 'Disabled',
        enable: 'Enable',
        disable: 'Disable',
        version: 'Version',

        viewModes: {
            grid: 'Grid View',
            list: 'List View',
        },

        pills: {
            official: 'Official',
            user: 'My Skills',
        },

        dialog: {
            createTitle: 'Create Skill',
            editTitle: 'Edit Skill',
            previewTitle: 'Skill Detail',
            name: 'Skill Name',
            namePlaceholder: 'Enter skill name (immutable after creation)',
            description: 'Description',
            descriptionPlaceholder: 'Enter description (optional)',
            tags: 'Tags',
            tagsPlaceholder: 'Type and press Enter to add',
            tagsReadonlyHint: 'Tags can only be set at creation',
            editingFile: 'Editing: {path}',
            binaryFileHint: 'Binary files cannot be edited online',
            unsavedChangesTitle: 'Unsaved Changes',
            unsavedChangesMessage: 'You have unsaved changes. Discard them and close?',
            discardChanges: 'Discard',
            continueEditing: 'Keep Editing',
        },

        workspace: {
            title: 'AI Workspace',
            backToList: 'Back to skill list',
            loadingTitle: 'Loading...',
            chatUnavailableTitle: 'AI chat unavailable',
            chatUnavailableDesc: 'The skill workspace failed to initialize or the backend service is not ready. Re-enter from the skill list later.',
            toolResultTitle: 'Tool Result',
            saving: 'Saving…',
        },

        fileTree: {
            newFile: 'New File',
            fileName: 'File name',
            fileNamePlaceholder: 'e.g. api.md, run.py (include the extension)',
            fileNameInvalid: 'File name cannot contain /',
            newDirectory: 'New Directory',
            directoryName: 'Directory name',
            parentPath: 'Parent path',
            rootPath: '(root)',
            rename: 'Rename',
            newName: 'New name',
            skillMdProtectedHint: 'SKILL.md cannot be renamed or deleted',
        },

        security: {
            violationsTitle: 'Content security check failed',
            blockedHint: 'Fix the following violations and save again',
            ruleId: 'Rule',
        },

        messages: {
            fetchListFailed: 'Failed to fetch skills',
            fetchDetailFailed: 'Failed to fetch skill detail',
            fetchFileFailed: 'Failed to fetch file content',
            createSuccess: 'Created',
            createFailed: 'Create failed',
            nameExists: 'A skill with this name already exists. Please change it and try again.',
            updateSuccess: 'Updated',
            updateFailed: 'Update failed',
            metadataSavedFilesNotSaved: 'Skill info saved, but some files failed to save. Check the violations and retry.',
            deleteSuccess: 'Deleted',
            deleteFailed: 'Delete failed',
            enableSuccess: 'Enabled',
            enableFailed: 'Enable failed',
            disableSuccess: 'Disabled',
            disableFailed: 'Disable failed',
            permissionDenied: 'No permission to operate this skill',
            updateFileFailed: 'Failed to save file',
            createDirectorySuccess: 'Directory created',
            createDirectoryFailed: 'Failed to create directory',
            createFileSuccess: 'File created',
            createFileFailed: 'Failed to create file',
            fileExists: 'A file with the same name already exists',
            renameSuccess: 'Renamed',
            renameFailed: 'Rename failed',
            deleteFileSuccess: 'File deleted',
            deleteFileFailed: 'Failed to delete file',
            emptyFolderNotDeletable: 'Empty folders cannot be deleted yet',
            workspaceInitFailed: 'Failed to initialize the AI workspace. Chat is temporarily unavailable.',
        },
    },
};
